import { useMemo } from 'react';
import Content from 'assets/js/components/Content';
import Breadcrumbs from 'assets/js/pages/engage/components/Breadcrumbs';
import { StepOne } from 'assets/js/pages/engage/components/MessageBuilder/Steps/StepOne';
import { StepThree } from 'assets/js/pages/engage/components/MessageBuilder/Steps/StepThree';
import { StepTwo } from 'assets/js/pages/engage/components/MessageBuilder/Steps/StepTwo';
import SuccessfullySent from 'assets/js/pages/engage/components/MessageBuilder/SuccessfullySent';
import { useCurrentEngageMessage } from 'customHooks/useCurrentEngageMessage';
import { useEngageCurrentStep } from 'customHooks/useEngageCurrentStep';
import { twMerge } from 'tailwind-merge';

const MessageBuilder = () => {
    const currentStep = useEngageCurrentStep();
    const { data: message } = useCurrentEngageMessage();
    const pageTitle = useMemo(() => {
        switch (currentStep) {
            case 1:
                return 'Filter contacts';
            case 2:
                return 'Compose';
            case 3:
                return 'Confirm';
            default:
                return 'Message';
        }
    }, [currentStep]);

    return (
        <Content
            dynamicWidthClass={'max-w-[850px]'}
            className={twMerge(
                'mb-[135px]',
                currentStep !== 1 && 'max-w-[850px]',
                message.channel === 'sms' && currentStep === 2 && 'max-w-[1200px]',
            )}
        >
            <p className="text-2xl font-medium">{pageTitle}</p>
            <Breadcrumbs current={message.internal_name || 'Message builder'} />
            {message.status === 'draft' ? (
                <div className={twMerge(currentStep === 3 && 'mt-8')}>
                    {currentStep === 1 && <StepOne />}
                    {currentStep === 2 && <StepTwo />}
                    {currentStep === 3 && <StepThree />}
                </div>
            ) : (
                <SuccessfullySent />
            )}
        </Content>
    );
};

export { MessageBuilder };
